import { render, staticRenderFns } from "./CustomForm.vue?vue&type=template&id=aee55a86"
import script from "./CustomForm.vue?vue&type=script&lang=js"
export * from "./CustomForm.vue?vue&type=script&lang=js"
import style0 from "./CustomForm.vue?vue&type=style&index=0&id=aee55a86&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports